exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slide-enter-active[data-v-44f7fff0],\r\n.slide-leave-active[data-v-44f7fff0] {\r\n  -webkit-transition: all 0.8s;\r\n  transition: all 0.8s;\n}\n.slide-enter[data-v-44f7fff0],\r\n.slide-leave-active[data-v-44f7fff0] {\r\n  opacity: 0;\r\n  -webkit-transform: translateX(20px);\r\n          transform: translateX(20px);\n}\n.slide-move[data-v-44f7fff0] {\r\n  -webkit-transition: all 0.8s;\r\n  transition: all 0.8s;\n}\n.slide-leave-active[data-v-44f7fff0] {\r\n  position: absolute;\n}\r\n", ""]);

// exports
